import React from 'react';
import { Skeleton, SkeletonContent, SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { bool } = proptypes;

export const Loader = ({ large = false }) => {
  return (
    <div className="sui-w-full sui-h-full" data-testid="card-loader">
      {large
        ? (
          <div className="sui-w-full sui-h-full">
            <Skeleton disablePadding orientation="vertical" grow>
              <SkeletonContent density="loose" disablePadding initialSize="4/4">
                <SkeletonBlock aspect="wide" />
              </SkeletonContent>
              <SkeletonContent density="loose" disablePadding initialSize="4/4">
                <SkeletonBlock aspect="wide" />
              </SkeletonContent>
              <SkeletonContent density="loose" disablePadding initialSize="4/4">
                <SkeletonBlock aspect="wide" />
              </SkeletonContent>
            </Skeleton>
          </div>
        )
        : (
          <div className="sui-w-full sui-h-full">
            <Skeleton disablePadding orientation="horizontal" grow>
              <SkeletonContent density="loose" disablePadding initialSize="1/4">
                <SkeletonBlock aspect="square" />
              </SkeletonContent>
              <SkeletonContent density="loose" disablePadding initialSize="1/4">
                <SkeletonBlock aspect="square" />
              </SkeletonContent>
              <SkeletonContent density="loose" disablePadding initialSize="1/4">
                <SkeletonBlock aspect="square" />
              </SkeletonContent>
              <SkeletonContent density="loose" disablePadding initialSize="1/4">
                <SkeletonBlock aspect="square" />
              </SkeletonContent>
            </Skeleton>
          </div>
        )}
    </div>
  );
};

Loader.displayName = 'SuperSkuLoader';

Loader.propTypes = {
  large: bool,
};
